import React, { useEffect, useRef } from 'react';

import { Grid } from 'theme-ui';
import CategoryName from '../../components/CategoryName/CategoryName';
import Filters from '../../components/Filters/Filters';
import { useGlobalContext } from '../../components/GlobalContextProvider/GlobalContextProvider';
import Loader from '../../components/Loader/Loader';
import PostPreview from '../../components/PostPreview';
import usePaginationOnScroll from '../../hooks/usePaginationOnScroll';
import { NotFound } from '../../shared-styled/blocks/SearchAndFiltersBlocks';
import {
  ListItem,
  ListItemDivider,
} from '../../shared-styled/blocks/listPagesBlocks';
import StickyWrapper from '../../shared-styled/layout/StickyWrapper';
import { IS_NEXT_EXPORT } from '../../utils/export';
import BasePageWrap from '../BasePage';

const ReportListPage = ({ items }) => {
  const { reportItems, setReportItems, isItemsLoading } = useGlobalContext();

  const reportItemsWrapper = useRef();
  usePaginationOnScroll(
    reportItemsWrapper,
    '/wt/api/nextjs/v1/page_by_path/?html_path=reports&limit=12&offset=12',
    reportItems,
    setReportItems,
    items.results,
  );

  useEffect(() => {
    setReportItems(
      (IS_NEXT_EXPORT ? items.results?.slice(0, 12) : items.results) || [],
    );
  }, []);

  return (
    <Grid
      columns={['4fr', '1fr 3fr 1fr', '1fr 2fr 1fr', '4fr 9fr 6fr']}
      p={['32px 20px 72px 20px', '70px 40px 100px 96px']}
    >
      <StickyWrapper>
        <CategoryName>Reports</CategoryName>
        <Filters />
      </StickyWrapper>
      <div ref={reportItemsWrapper}>
        {reportItems.length > 1 ? (
          <>
            {reportItems.map((report) => (
              <ListItem key={report.slug}>
                <PostPreview {...report} href={`/reports/${report.slug}`} />
                <ListItemDivider />
              </ListItem>
            ))}
            {isItemsLoading && <Loader isPagination={true} isSmall={true} />}
          </>
        ) : isItemsLoading || IS_NEXT_EXPORT ? (
          <Loader isFullHeight={true} />
        ) : (
          <NotFound>No Results Found</NotFound>
        )}
      </div>
    </Grid>
  );
};

ReportListPage.defaultProps = {
  items: {},
};

export default BasePageWrap(ReportListPage);
